<template>
  <main-layout>
    <v-container v-show="!editModal">
      <div style="font-size: 23px" class="primary--text mb-3">แบบร่าง</div>
      <div>
        <div class="add-product mb-3" @click="showCreate">
          <em class="fas fa-plus mr-2" />
          เพิ่มโพสต์
        </div>
        <FacebookPostList ref="draftList" :published="false">
          <template #default="{ item }">
            <FacebookPostItem
              :value="item"
              @edit="showEdit"
              @copy="onCopy"
              @delete="onDelete"
              @view="showRead"
              @errorView="handleErrorView"
            />
          </template>
        </FacebookPostList>
      </div>
      <v-divider class="my-3"></v-divider>
      <div style="font-size: 23px" class="primary--text mb-3">โพสต์ไปแล้ว</div>
      <div>
        <FacebookPostList ref="publishedList" published>
          <template #default="{ item }">
            <FacebookPostItem
              :value="item"
              @edit="showEdit"
              @copy="onCopy"
              @delete="onDeletePublishPost"
              @view="showRead"
              @errorView="handleErrorView"
            />
          </template>
        </FacebookPostList>
      </div>
    </v-container>
    <v-container v-if="editModal" width="600px" persistent>
      <v-card v-if="editModal">
        <PostEdit
          :loadinggroup="loadinggroup"
          :group-options="groupOptions"
          :channels="channels"
          :edittype="edittype"
          :editdata="editdata"
          :is-published="IsPublished"
          @onSave="onSave"
          @close="editModal = false"
        ></PostEdit>
      </v-card>
    </v-container>
    <v-dialog
      v-if="
        msgErrorId &&
        showMsgError &&
        ((showMsgErrorData && showMsgErrorData.formatData) ||
          (select_public_fail && select_public_fail.length))
      "
      v-model="showMsgError"
      max-width="500px"
    >
      <v-card>
        <div class="text-xs-right">
          <v-btn flat small fab @click="handleCloseShowMsgError">
            <v-icon> close </v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <div class="intent-item" style="padding: 10px 15px 0px">
            <div class="mb-3" style="font-size: 20px; text-align: center; font-weight: 600">
              รายการที่โพสต์ไม่สำเร็จ
            </div>
            <div class="error-list">
              <template v-if="showMsgErrorData && showMsgErrorData.formatData">
                <v-layout
                  v-for="(errorData, index) in showMsgErrorData.formatData"
                  :key="`showMsgErrorData-${index + 1}`"
                  row
                  wrap
                >
                  <v-flex xs12>
                    <span style="font-weight: 500">Page ID</span> : {{ errorData.pageId }}
                  </v-flex>
                  <v-flex xs12>
                    <span style="font-weight: 500">Page Name</span> : {{ errorData.pageName }}
                  </v-flex>
                </v-layout>
              </template>
              <template v-if="select_public_fail && select_public_fail.length">
                <div class="primary--text">Public ไม่สำเร็จ</div>
                <v-layout
                  v-for="(errorPage, index) in select_public_fail"
                  :key="`showMsgErrorPage-${index + 1}`"
                  row
                  wrap
                >
                  <v-flex xs12>
                    <span style="font-weight: 500">Page ID</span> : {{ errorPage.channel_id }}
                  </v-flex>
                  <v-flex xs12>
                    <span style="font-weight: 500">Page Name</span> : {{ errorPage.page_name }}
                  </v-flex>
                  <v-flex v-if="errorPage.error_reason" xs12 class="error--text">
                    <span style="font-weight: 500">Reason</span> :
                    {{ transformFacebookError(errorPage.error_reason) || '-' }}
                  </v-flex>
                </v-layout>
              </template>
            </div>
            <div style="text-align: center">
              กรุณากดตรวจสอบการส่งข้อมูลอีกครั้ง ก่อนการสร้างโพสต์
            </div>
            <v-layout row justify-center>
              <v-btn
                color="primary"
                :loading="syncIsPublicPostloading"
                @click="handlePostSyncIsPublic(msgErrorId)"
                >ตรวจสอบอีกครั้ง</v-btn
              >
            </v-layout>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </main-layout>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import PostEdit from './PostEdit.vue'
import axios from 'axios'
import powerbuyShopServicesApi from '@/api/powerbuy-post'
import FacebookPostList from './FacebookPostList.vue'
import FacebookPostItem from './FacebookPostItem.vue'

export default {
  components: {
    PostEdit,
    FacebookPostList,
    FacebookPostItem
  },
  data() {
    return {
      loadinggroup: true,
      channels: [],
      groupOptions: [],
      loading: false,
      totalDraft: 0,
      offsetDraft: 0,
      limitDraft: 10,
      pagetmpDraft: 1,
      pageNumberDraft: 1,
      dataDraft: [],
      totalPublish: 0,
      offsetPublish: 0,
      limitPublish: 10,
      pagetmpPublish: 1,
      pageNumberPublish: 1,
      dataPublish: [],
      editModal: false,
      edittype: '',
      editdata: '',
      IsPublished: false,
      showMsgError: false,
      showMsgErrorData: null,
      msgErrorId: null,
      select_public_fail: null,
      loadingMsgError: false,
      syncIsPublicPostloading: false
    }
  },
  computed: {
    pagelengthDraft() {
      if (this.totalDraft) {
        return Math.ceil(this.totalDraft / 10)
      } else {
        return 1
      }
    },
    pagelengthPublish() {
      if (this.totalPublish) {
        return Math.ceil(this.totalPublish / 10)
      } else {
        return 1
      }
    },
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getChannel()
    this.getGroups()
  },
  methods: {
    async handlePostSyncIsPublic(id) {
      try {
        this.syncIsPublicPostloading = true
        await powerbuyShopServicesApi.putSyncIsPublic(id)
        await this.$swal.fire({
          title: this.$t('Successfully'),
          type: 'success'
        })
        this.$refs.publishedList.reload()
        this.handleCloseShowMsgError()
      } catch (error) {
        this.$swal.fire({ type: 'error', text: 'เรียกข้อมูลไม่สำเร็จ' })
      } finally {
        this.syncIsPublicPostloading = false
      }
    },
    handleCloseShowMsgError() {
      this.showMsgErrorData = null
      this.showMsgError = false
      this.msgErrorId = null
      this.select_public_fail = null
    },
    async handleErrorView(item) {
      try {
        this.$store.state.loading = true

        const response = await powerbuyShopServicesApi.getFacebookPostPublicItems(item.id, {
          pageid: this.selectedBot.pageid,
          limit: 1000,
          offset: 0,
          publish: true
        })

        if (response.status !== 200) return

        const { data } = response.data

        const newItem = { ...item }
        newItem.check_page_published_post_list = data

        if (data && data.length > 0) {
          newItem.public_fail = data.filter(
            (page) =>
              page.is_published === false ||
              ((page.is_published || page.is_published === null) && page.error_reason)
          )
        }

        this.handleSendMsgShowError(newItem)
      } catch (error) {
        console.error(error)
      } finally {
        this.$store.state.loading = false
      }
    },
    async handleSendMsgShowError(data) {
      // channels
      const vm = this
      try {
        let formatData = []
        vm.loadingMsgError = true
        vm.msgErrorId = data.id
        const errorData = JSON.parse(data.error_reason)
        if (data.public_fail && data.public_fail.length) {
          this.select_public_fail = data.public_fail
          vm.showMsgError = true
        }
        if (errorData && errorData.length) {
          errorData.forEach((element) => {
            if (element.error && element.pageid) {
              const errorDetail = JSON.parse(element.error)
              const pageData = vm.channels.find((x) => x.channelid == element.pageid)
              let pageName = ''
              if (pageData) {
                pageName = pageData.channelname
              }
              const pageId = element.pageid
              formatData.push({
                errorDetail,
                pageName,
                pageId
              })
            }
          })
        }
        if (formatData && formatData.length > 0) {
          data.formatData = formatData
          vm.showMsgErrorData = data
          vm.showMsgError = true
        } else if (!(data.public_fail && data.public_fail.length)) {
          vm.$swal.fire({ type: 'error', text: 'เรียกข้อมูลไม่สำเร็จ' })
        }
      } catch (error) {
        vm.msgErrorId = null
        vm.$swal.fire({ type: 'error', text: 'เรียกข้อมูลไม่สำเร็จ' })
      } finally {
        vm.loadingMsgError = false
      }
    },
    getGroups() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      api.getPowerbuyGroup(data, (err, response) => {
        this.groupOptions = response.data.map((el) => {
          return { ...el, id: parseInt(el.id) }
        })
        this.loadinggroup = false
      })
    },
    async getFbName(userid) {
      return new Promise(async (resolve) => {
        var vm = this
        var fbusersname = vm.$store.state.facebook_users_name
        if (!fbusersname.some((el) => el.id == userid))
          var result = await axios.get(
            `https://graph.facebook.com/${userid}?fields=name&access_token=${vm.selectedBot.page_access_token}`
          )
        if (result) {
          resolve(result.data.name)
        } else resolve(getFbName)
      })
    },
    onDelete(item) {
      this.$swal
        .fire({
          text: 'ยืนยันการลบ ?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            var data = {
              pageid: this.selectedBot.pageid,
              id: item.id
            }
            this.loading = true
            api.deletePowerbuyPost(data, (response) => {
              this.loading = false
              this.onSave()
            })
          }
        })
    },
    onCopy(item) {
      this.$swal
        .fire({
          title: this.$t('คุณต้องการจะคัดลอกข้อมูลใช่หรือไม่'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            this.loading = true
            var data = {
              pageid: this.selectedBot.pageid,
              name: item.name + ' - copy',
              channelIdList: item.channelidlist,
              messages: item.messages,
              photoUrl: item.photourl,
              scheduleTime: item.scheduletime,
              postType: item.posttype ? item.posttype : 'message',
              attachmedia: item.attachmedia,
              publish: false // boolean >> true คือโพสต์ไป facebook, false คือ แบบร่าง
            }

            api.powerbuyCreateFacebookPost(data, (err, response) => {
              this.loading = false
              this.$refs.draftList.reload({ reset: true })
              this.$refs.publishedList.reload({ reset: true })
            })
          }
        })
    },
    changePageDraft(val) {
      var vm = this
      if (this.pagetmpDraft == val) {
        //dont do shit
      } else {
        this.pagetmpDraft = val
        vm.offsetDraft = vm.pageNumberDraft * this.limitDraft - this.limitDraft
        if (vm.pageNumberDraft != 1) {
          vm.offsetDraft + 1
        }
        // this.getData(false)
      }
    },
    changePagePublish(val) {
      var vm = this
      if (this.pagetmpPublish == val) {
        //dont do shit
      } else {
        this.pagetmpPublish = val
        vm.offsetPublish = vm.pageNumberPublish * this.limitPublish - this.limitPublish
        if (vm.pageNumberPublish != 1) {
          vm.offsetPublish + 1
        }
        // this.getData(true)
      }
    },
    getData(isPublish) {
      const vm = this
      vm.loading = true
      var data = {
        pageid: vm.selectedBot.pageid,
        limit: vm['limit' + (isPublish ? 'Publish' : 'Draft')],
        offset: vm['offset' + (isPublish ? 'Publish' : 'Draft')],
        publish: isPublish
      }

      api.powerbuyGetFacebookPostManagement(data, (err, response) => {
        vm.loading = false
        if (isPublish) {
          vm.dataPublish = response.data
          vm.totalPublish = response.total
          vm.setPublicFailData(vm.dataPublish)
        } else {
          vm.dataDraft = response.data
          vm.totalDraft = response.total
        }

        vm.total = response.total
      })
    },
    setPublicFailData(dataPublish) {
      if (dataPublish && dataPublish.length) {
        for (let i = 0; i < dataPublish.length; i++) {
          if (
            dataPublish[i].check_page_published_post_list &&
            dataPublish[i].check_page_published_post_list.length
          ) {
            dataPublish[i].public_fail = dataPublish[i].check_page_published_post_list.filter(
              (page) =>
                page.is_published === false ||
                ((page.is_published || page.is_published === null) && page.error_reason)
            )
          }
        }
        this.dataPublish = dataPublish
      }
    },
    getChannel() {
      var data = {
        pageid: this.selectedBot.pageid // pageid ที่เข้ามาจาก cms
      }

      this.loading = true
      api.powerbuyGetChannel(data, (err, response) => {
        this.loading = false
        this.channels = response.data
      })
    },
    showCreate() {
      this.edittype = 'create'
      this.editModal = true
      this.IsPublished = false
    },
    showEdit(item) {
      this.edittype = 'edit'
      this.editdata = item
      this.editModal = true
      this.IsPublished = item.postaction ? ['edited', 'published'].includes(item.postaction) : false
    },
    showRead(item) {
      this.edittype = 'read'
      this.editdata = item
      this.editModal = true
    },
    onSave() {
      this.$swal.fire({
        text: 'สำเร็จ',
        type: 'success'
      })
      this.editModal = false
      this.$refs.draftList.reload({ reset: true })
      this.$refs.publishedList.reload({ reset: true })
    },
    onDeletePublishPost(item) {
      this.$swal
        .fire({
          title: this.$t('คุณต้องการจะลบโพสต์ใช่หรือไม่'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            this.loading = true
            var data = {
              pageid: this.selectedBot.pageid,
              postId: item.id,
              channelIdList: item.channelidlist
            }

            api.powerbuyDeleteFacebookPublishPost(data, (err, response) => {
              this.loading = false
              this.onSave()
            })
          }
        })
    },
    transformFacebookError(value) {
      try {
        const parsed = JSON.parse(value)
        if (!parsed) return ''
        const { error } = parsed
        const { code, message } = error
        if (Number(code) === 190) {
          return 'เนื่องจาก Access Token Facebook หลุดการเชื่อมต่อ กรุณา Login ระบบอีกครั้ง'
        }
        return message
      } catch (error) {
        return ''
      }
    }
  }
}
</script>

<style lang="scss">
.add-product {
  height: 80px;
  border: dashed rgb(189, 189, 189) 3px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(189, 189, 189);
  cursor: pointer;
  border-radius: 10px;
  font-size: 23px;
  transition: all 0.1s ease-out;
}
.add-product:hover {
  color: #ee6e73;
  border: dashed #ee6e73 3px;
  // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.error-box {
  cursor: pointer;
  background-color: #ee6e73;
  width: max-content;
  padding: 5px 10px;
  border: 1px solid transparent;
  border-radius: 10px;
  font-size: 14px;
  color: white;
}
.error-list {
  background-color: rgb(228, 228, 228);
  padding: 20px 30px;
  max-height: 250px;
  overflow: scroll;
  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #ffffff;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #cccccc;
    border-radius: 0px;
    border: 3px none #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/FacebookPostManager/main.vue